import { MobileOfferPrice } from '@numeo/types'

export function OfferPrices({ prices, periods }: { prices: MobileOfferPrice[]; periods: number }) {
    return (
        <div className="max-h-72 overflow-auto rounded-lg border border-slate-200 dark:border-slate-700" tabIndex={0} aria-label="Regional store prices">
            <table className="w-full text-left text-sm">
                <caption className="sr-only">Store prices for {periods} monthly payments, then regular monthly renewal</caption>
                <thead className="sticky top-0 bg-slate-50 text-xs text-slate-500 dark:bg-slate-800 dark:text-slate-400">
                    <tr>
                        <th className="px-3 py-3">Country</th>
                        <th className="px-3 py-3">Offer / month</th>
                        <th className="px-3 py-3">Then / month</th>
                        <th className="px-3 py-3">Saving</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                    {prices.map((price) => (
                        <tr key={price.country}>
                            <td className="px-3 py-2.5">{price.country}</td>
                            <td className="whitespace-nowrap px-3 py-2.5 font-medium">
                                {price.discountedPrice} {price.currency}
                            </td>
                            <td className="whitespace-nowrap px-3 py-2.5 text-slate-500 dark:text-slate-400">
                                {price.regularPrice} {price.currency}
                            </td>
                            <td className="px-3 py-2.5">{Number(price.effectivePercentOff.toFixed(2))}%</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}
